<template>
  <Walkthrough 
    roomName="La Oficina"
    roomKey="office"
    :steps="steps"
    :backgroundImage="backgroundImage"
    language="spanish"
  />
</template>
<script>

export default {
  name: 'Oficina',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/office-1920x1280.jpg",
      steps: [
        "Mira a la izquierda, y luego mira el escritorio.",
        "Ahora que sabes que hay una carta en el escritorio, mira la carta.",
        "La letra contiene pistas para el interruptor de circuito. Observa los cuatro objetos en la sala que se mencionan en la carta y el orden en que aparecen. Luego mira esos objetos en la sala e identifica sus colores.",
        "Ahora que conoces los cuatro colores, mira a la derecha e inspecciona el interruptor. Ahora puede ingresar los colores verde, rojo, azul, blanco y la energía debería comenzar a fluir en la habitación. Esto será útil más tarde.",
        "Ahora mira hacia abajo e inspecciona la trampilla. Deberías encontrar una palanca dentro.",
        "Ahora que tienes la palanca, mira a la izquierda en el escritorio y luego usa la palanca en el cajón. Deberías encontrar un destornillador.",
        "Ahora que tienes el destornillador, puedes mirar hacia arriba y usar el destornillador en la rejilla de ventilación. Adentro deberías encontrar un martillo.",
        "Con el martillo que tienes ahora, puedes mirar a la izquierda y usar el martillo para romper el marco de vidrio grueso alrededor de la foto. Esto debería revelar un mensaje en la parte posterior.",
        "Usando el mensaje que encontraste en la parte posterior de la foto, deberías poder tomar la edad de la hija (5 años) y la fecha de la foto (1995) para usarlas como el código de acceso para la caja fuerte, 0390 (el cumpleaños de la hija, Marzo de 1990),",
        "Ahora, miras a la derecha e inspeccionas la caja fuerte. ¡Debes ingresar el código 0390 en la caja fuerte y encontrar la clave final!",
        "Usando la llave ahora puedes mirar hacia adelante, usa la llave en la puerta y escapa a la libertad. Felicitaciones, has escapado. ¡Intenta resolver la siguiente habitación por tu cuenta!",
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/walkthrough/es/office.vue